// import React from 'react';
// import success from '../assets/success.svg';

// const PasswordRequestModal = ({ isOpen, onClose, onBookAnotherRide }) => {
//   if (!isOpen) return null;

//   return (
//     <div
//       className='d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100'
//       style={{
//         backgroundColor: 'rgba(0, 0, 0, 0.4)',
//         zIndex: 1050,
//         backdropFilter: 'blur(5px)',
//       }}
//     >
//       <div
//         className='d-flex flex-column justify-content-center align-items-center bg-white shadow'
//         style={{
//           width: '90%',
//           maxWidth: '700px',
//           height: '500px',
//           borderRadius: '20px',
//           padding: '40px 40px',
//         }}
//       >
//         <div
//           className='d-flex justify-content-center align-items-center mx-auto mb-3'
//           style={{
//             width: '60px',
//             height: '60px',
//             backgroundColor: '#28a745',
//             borderRadius: '50%',
//           }}
//         >
//           <img src={success} alt='success icon' />
//         </div>
//         <h3 className='fw-bold text-center mb-2'>
//           The request has been sent successfully.
//         </h3>
//         <p className='text-muted text-center mb-4'>
//           Your request to update password has been successfully sent! Please
//           check your email soon for further details and updates.
//         </p>
//         <div
//           className='d-flex flex-wrap justify-content-center gap-3'
//           style={{ width: '100%' }}
//         >
//           <button
//             className='btn px-4'
//             style={{
//               backgroundColor: '#fff',
//               color: '#1f1f21',
//               border: '1px solid #969696',
//               padding: '5px 20px',
//               borderRadius: '8px',
//               fontWeight: '600',
//               cursor: 'pointer',
//             }}
//             onClick={onClose}
//           >
//             Back to Dashboard
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PasswordRequestModal;

import React from 'react';
import success from '../assets/success.svg';

const PasswordRequestModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className='d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100'
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        zIndex: 1050,
        backdropFilter: 'blur(5px)',
      }}
    >
      <div
        className='d-flex flex-column justify-content-center align-items-center bg-white shadow'
        style={{
          width: '90%',
          maxWidth: '700px',
          height: '500px',
          borderRadius: '20px',
          padding: '40px 40px',
        }}
      >
        <div
          className='d-flex justify-content-center align-items-center mx-auto mb-3'
          style={{
            width: '60px',
            height: '60px',
            backgroundColor: '#28a745',
            borderRadius: '50%',
          }}
        >
          <img src={success} alt='success icon' />
        </div>
        <h3 className='fw-bold text-center mb-2'>
          The request has been sent successfully.
        </h3>
        <p className='text-muted text-center mb-4'>
          Your request to update password has been successfully sent! Please
          check your email soon for further details and updates.
        </p>
        <div
          className='d-flex flex-wrap justify-content-center gap-3'
          style={{ width: '100%' }}
        >
          <button
            className='btn px-4'
            style={{
              backgroundColor: '#fff',
              color: '#1f1f21',
              border: '1px solid #969696',
              padding: '5px 20px',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
            onClick={onClose}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordRequestModal;
